'use strict';

var DateRangeChart = function DateRangeChart(AbstractChart, chartGroups, chartSimpleBars, chartCircles, chartTiles, chartXAxis, chartYAxis, chartConstants) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    var self = this;
    AbstractChart.call(self, container);

    // chart components
    var groups = chartGroups('label', formatters.tooltipFormatter, true);
    var m1Bars = chartSimpleBars('m1');
    var m2Bars = chartSimpleBars('m2');
    var tiles = chartTiles('label', 'm2', 'tiles').withHeight(2);
    var circles = chartCircles('circles');
    var xAxis = chartXAxis(formatters.xAxisTickFormatter).withTextRotation(chartConstants.AXIS.SKEW.DEG_30).withoutLine().withRepetition(1);
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT);
    this.render = function (data, range) {
      data = data || this.data;
      this.initChart(data, range, chartParams(data.length));
      this.scales = chartScales(this.params, this.data, this.visibleXRange);
      this.callForDataGroup([yAxisLeft, groups, m2Bars, m1Bars, tiles, circles, xAxis], this.scales);
    };
    this.domainChange = function (range) {
      this.render(this.data, range);
    };
    this.withMetric = function (metric) {
      yAxisLeft.label(metric.label);
      return this;
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
DateRangeChart.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsSimpleBars', 'ChartElementsCircles', 'ChartElementsTiles', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsConstants'];
module.exports = DateRangeChart;